import { Component, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../../../_services/_common/common.service';

@Component({
    selector: 'lokos-refresh-button',
    standalone: false,
    templateUrl: './refresh-button.component.html',
    styleUrl: './refresh-button.component.scss'
})
export class RefreshButtonComponent {

  @Output() afteRrefreshClick = new EventEmitter();

  constructor(private commonService: CommonService) { }

  refreshBtn(){
      this.commonService.tableRefreshSubject.next(true);
      this.afteRrefreshClick.emit();
  }
}
